import { Intent } from "./Intent.js";
import { SimAtomic } from "../simstance/SimAtomic.js";
import { isIntentSubscribe } from "./IntentSubscribe.js";
import { Subject } from "@dooboostore/core";
const isRouterPublishType = (it) => typeof it === "object" && it !== null && typeof it.router === "string" && typeof it.rootRouter === "function";
const isSymbolPublishType = (it) => typeof it === "object" && it !== null && "symbol" in it && "path" in it;
const isSchemePublishType = (it) => typeof it === "object" && it !== null && "scheme" in it && "path" in it;
const isTypePublishType = (it) => typeof it === "object" && it !== null && "type" in it && "target" in it;
class IntentManager {
  constructor(simpleApplication, simstanceManager, routerManager, simOption) {
    this.simpleApplication = simpleApplication;
    this.simstanceManager = simstanceManager;
    this.routerManager = routerManager;
    this.simOption = simOption;
    this.subject = new Subject();
  }
  get observable() {
    return this.subject.asObservable();
  }
  async makeIntentData(it, data) {
    const target = [];
    const rootRouter = isRouterPublishType(it) ? it.rootRouter : this.simOption.rootRouter;
    if (isRouterPublishType(it)) {
      it = it.router;
    }
    const routerMatch = typeof it === "string" && it.match(/^Router\((.+)\):\/(.*)$/);
    if (routerMatch && typeof it === "string") {
      const routerBasePath = routerMatch[1];
      const actualPath = routerMatch[2];
      const routerModule = await this.routerManager.routing(routerBasePath, {
        router: rootRouter
      });
      const instance = routerModule.getModuleInstance();
      if (instance) {
        target.push(instance);
      }
      it = new Intent(actualPath, data);
    } else if (isSymbolPublishType(it)) {
      it = new Intent({ symbol: it.symbol, uri: it.path }, data);
    } else if (isTypePublishType(it)) {
      it = new Intent({ type: it.type, target: it.target }, data);
    } else if (isSchemePublishType(it)) {
      it = new Intent(`${it.scheme}://${it.path}`, data);
    } else if (typeof it === "string") {
      it = new Intent(it, data);
    }
    const intent = it;
    if (!routerMatch) {
      if (intent.types) {
        target.push(...this.simstanceManager.findSims({ type: intent.types }));
      } else if (intent.symbols) {
        target.push(...intent.symbols.map((sym) => this.simstanceManager.findSims(sym)).flat());
      } else if (intent.scheme) {
        target.push(...this.simstanceManager.getSimConfig(intent.scheme));
      } else {
        target.push(...this.simstanceManager.getSimAtomics());
      }
    }
    return { intent, target };
  }
  async publishMeta(it, data) {
    const { intent, target } = await this.makeIntentData(it, data);
    const r = [];
    const targetInstances = target.map((it2) => {
      if (it2 instanceof SimAtomic) {
        return it2.getValue();
      } else {
        return it2;
      }
    });
    this.subject.next(intent);
    for (let data2 of targetInstances) {
      let orNewSim = data2;
      if (orNewSim) {
        const filteredPaths = intent.paths.filter((i) => i);
        if (filteredPaths.length > 0) {
          let callthis = orNewSim;
          let lastProp = "";
          filteredPaths.forEach((i) => {
            callthis = orNewSim;
            orNewSim = orNewSim?.[i];
            lastProp = i;
          });
          if (orNewSim && typeof orNewSim === "function") {
            const intentData = Array.isArray(intent.data) ? intent.data : intent.data !== void 0 ? [intent.data] : [];
            const result = await this.simstanceManager.executeBindParameterSimPromise({
              target: callthis,
              targetKey: String(lastProp),
              parameterCount: intentData.length,
              inputParameters: intentData,
              firstCheckMaker: [
                (obj, token, idx) => {
                  if (idx < intentData.length) {
                    return intentData[idx];
                  }
                  if (token === Intent && idx === 0) {
                    return intent;
                  }
                }
              ]
            });
            r.push(result);
          } else if (orNewSim) {
            callthis[lastProp] = intent.data;
            r.push(callthis[lastProp]);
          }
        } else {
          const intentData = Array.isArray(intent.data) ? intent.data : intent.data !== void 0 ? [intent.data] : [];
          if (isIntentSubscribe(orNewSim)) {
            r.push(orNewSim.intentSubscribe(...intentData));
          }
        }
      }
    }
    return { return: r, target };
  }
  async publish(it, data) {
    const rdata = await this.publishMeta(it, data);
    return rdata.return;
  }
}
export {
  IntentManager,
  isRouterPublishType,
  isSchemePublishType,
  isSymbolPublishType,
  isTypePublishType
};
//# sourceMappingURL=IntentManager.js.map
